import { parseTaskFilter } from "helpers/taskFilterSerialization";
import { matchesSearchQuery, tokenizeSearchQuery } from "helpers/textSearch";

// An empty selection means "no filter applied", so everything matches.
const matchesSelection = (selectedIds: string[], resourceIds: string[] = []): boolean =>
  selectedIds.length === 0 ||
  resourceIds.some((resourceId) => selectedIds.includes(resourceId));

class CalendarToggleTracker {
  private cropNameFilters: string[] = [];

  private taskFilter: Record<string, boolean>;

  selectedPlantingLocationIds: string[] = [];

  selectedLayerGroupIds: string[] = [];

  visiblePlantings = new Set<number>();

  groupingMapping: Record<
    string,
    { plantingLocationIds: string[]; layerGroupIds: string[] }
  > = {};

  constructor() {
    this.setCropNameFilter("");
    this.taskFilter = parseTaskFilter(localStorage.getItem("calendar-task-filter"));
  }

  // resource titles (crop names)
  isResourceTitleVisible(resourceTitle?: string): boolean {
    if (resourceTitle === undefined) {
      return false;
    }

    return matchesSearchQuery(this.cropNameFilters, [resourceTitle]);
  }

  isResourceSelectedByFilter(plantingId: number): boolean {
    const grouping = this.groupingMapping[plantingId];

    return (
      matchesSelection(this.selectedLayerGroupIds, grouping?.layerGroupIds) &&
      matchesSelection(this.selectedPlantingLocationIds, grouping?.plantingLocationIds)
    );
  }

  setCropNameFilter(query: string) {
    this.cropNameFilters = tokenizeSearchQuery(query);
  }

  // tasks
  setTaskFilter(taskFilter: Record<string, boolean>) {
    this.taskFilter = taskFilter;
  }

  isTaskVisible(taskType: string): boolean {
    return this.taskFilter[taskType] ?? false;
  }

  // plantings
  hidePlanting(plantingId: number) {
    this.visiblePlantings.delete(plantingId);
  }

  showPlanting(plantingId: number) {
    this.visiblePlantings.add(plantingId);
  }

  isPlantingVisible(plantingId: number): boolean {
    return this.visiblePlantings.has(plantingId);
  }
}

export default CalendarToggleTracker;
